// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12qNL","content":"styles_content__5bHH_","tableWrap":"styles_tableWrap__1LfIm"};